export const GET_FEEDBACK = "GET_FEEDBACK"
export const GET_FEEDBACK_SUCCESS = "GET_FEEDBACK_SUCCESS"
export const GET_FEEDBACK_FAIL = "GET_FEEDBACK_FAIL"

export const TOGGLE_LOADING = "TOGGLE_LOADING"
export const DELETE_FEEDBACK = "DELETE_FEEDBACK"